 // this is the loader of the emscripten initialization
                import EmscriptenInit from "/Users/polx/projects/Cabri/software/cabri3d/build/wasm-tool-emscripten/web/dependencies.js";
                console.log("Invoking EmscriptenInit.", typeof(EmscriptenInit));
                // TODO: add version information from git or the hash of webpack
                let listener = null;
                console.log("Initializing Emscripten runtime");
                const emi = EmscriptenInit();
                console.log("Initialized Emscripten runtime");
                window.emi = emi;
                // --- this is /Users/polx/projects/Cabri/software/cabri3d/dependencies.emsc.js
                let s=function() {
                    // this glue file is a placeholder so that
// webpack requires the cpp files which get compiled to o files.
// and produces an emscripten js for wasm loading
//
// it is injected after EmscriptenRuntime is created by the emscripten loader
// and is thus ready to be used.
// EmscriptenRuntime is the Module object created by emscripten's load of WebAssembly
// this file is not a module!

console.log("Dependencies are being loaded !");
// add here all glue objects and codes beyond that produced by emscripten

                }; s();
                // --- end include /Users/polx/projects/Cabri/software/cabri3d/dependencies.emsc.js
                export default emi;
                